import Store from '../Store';
import structure from '../../data/ressources/Market';

const MarketStore = new Store('markets', structure);

export {MarketStore};